import { type FC } from "react";
import { Placeholder } from "semantic-ui-react";
import CroppedThumbnail from "components/croppedThumbnail/CroppedThumbnail";

export const ContentPlaceholder: FC = () => {
  return (
    <div className="pack-context-item">
      <div>
        <CroppedThumbnail
          placeholderContent={
            <Placeholder data-testid="context-item-image-placeholder">
              <Placeholder.Image />
            </Placeholder>
          }
        />
      </div>
      <div className="pack-context-placeholder">
        <Placeholder data-testid="pack-context-selection-placeholder">
          <Placeholder.Line />
        </Placeholder>
      </div>
    </div>
  );
};
